/** @jsx jsx */
import { jsx, Grid, Box } from 'theme-ui'
import { FC } from 'react'
import { CollectionTemplateType, FluidImageObjectType } from '~/@types/models'
import ProductItem from '~/components/product-item'
import CollectionLayout from '~/components/layout/collection-layout'
import CollectionProducts from '~/containers/collection-products'
import isolateFilters from '~/utils/filtering'
import { graphql, Link, useStaticQuery } from 'gatsby'

type Props = CollectionTemplateType

const query = graphql`
  query {
    allShopifyCollection(
      filter: {
        handle: {
          in: [
            "contemporary-rugs"
            "traditional-rugs"
            "moroccan-rugs"
            "performance"
            "textured-rugs"
            "antique-rugs"
          ]
        }
      }
      sort: { fields: metafields___rugcollectionlinkorder, order: ASC }
    ) {
      edges {
        node {
          id
          handle
          title
          metafields {
            collectionCustomImageUrl
          }
          image {
            originalSrc
            srcDesktopMedium
          }
          seo {
            title
            description
          }
        }
      }
    }
  }
`

interface QueryResult {
  allShopifyCollection: {
    edges: {
      node: Array<{
        id: string
        handle: string
        title: string
        metafields: {
          collectionCustomImageUrl: string
        }
        image: {
          originalSrc: string
          srcDesktopMedium: string
        }
      }>
    }
  }
}

const CollectionRugs = ({ pageContext: { data } }: Props) => {
  const filterData = isolateFilters(data)
  const showFeaturedCollections = data.handle === 'rugs'
  const featuredCollectionsList = useStaticQuery<QueryResult>(query).allShopifyCollection.edges

  return (
    <CollectionLayout
      title={data.title}
      description={data.description}
      ankleContent={data.metafields?.ankleContent}
      heroHeader={{
        isExternal: true,
        ...(data.imageResponsive && {
          imageSet: data.imageResponsive,
        }),
      }}
      featuredCollectionsList={featuredCollectionsList}
      handle={data.handle}
      showFeaturedCollections={showFeaturedCollections}
    >
      <CollectionProducts
        collectionHandle={data.handle}
        initialData={data.products}
        pagination={data.pagination}
        filters={filterData}
        showFilter={true}
      >
        {props => (
          <Grid columns={[1, 2]} gap={20} className="product-list-rugs">
            {props.products.map(item => {
              return (
                <Box key={item.id}>
                  <ProductItem
                    product={{
                      ...item,
                      mainImage: item.mainImage || item.mainImageLifestyle,
                    }}
                    visibleVariantsCount={9}
                    productImageRatio={1}
                    imageDimensions={{
                      width: [530, 1000],
                      height: [670, 1000],
                    }}
                    aspectRatio={false}
                  />
                </Box>
              )
            })}
          </Grid>
        )}
      </CollectionProducts>
    </CollectionLayout>
  )
}
export default CollectionRugs
